export enum QuoteTypeName {
  'STANDARD',
  'MAINTENANCE',
}

export enum QuoteType {
  STANDARD = 1,
  MAINTENANCE,
}
